<template>
    <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="Branch" class="col-sm-2 col-form-label font-weight-bold">Branch</label>
            <div class="col-sm-6">
              <select name="tahun" id="branch" v-model="branch" class="custom-select custom-select-sm">
                <option v-for="bran in branchs" :value="bran.id" :key="bran.id">{{bran.name}}</option>
              </select>
            </div>
          </div>
          <div class="from-group row">
            <label for="" class="col-sm-2 col-form-label font-weight-bold">Date</label>
            <div class="col-sm-6">
                <date-picker v-model="date" lang="en" format="YYYY" type="year"></date-picker>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-6">
              <button @click="submit" class="btn btn-primary">Submit</button>
            </div>
          </div>
          <b-row>
            <template v-if="listMetric.length > 0">
              <div class="table-responsive b-table-sticky-header">
                  <table class="table b-table table-bordered table-sticky b-table-no-border-collapse">
                      <thead>
                          <tr>
                              <th>HR&GA {{year}}</th>
                              <th>Keterangan</th>
                              <template v-for="month in headerMonth" >
                                  <th :key="month.text">
                                    {{month.text}}
                                  </th>
                              </template>
                              <th class="of-the-year">Of the Year {{year}}</th>
                          </tr>
                      </thead>
                        <tbody>
                            <template v-for="metric in listMetric">
                                <tr :key="metric.id">
                                    <td>
                                        <span :class="metric.is_category == 1 && metric.pid == 0? 'parent-category' :
                                        metric.pid > 0 ?
                                        'child-category' : ''">
                                            {{metric.label}}
                                        </span>
                                    </td>
                                    <td align="center">{{metric.desc}}</td>
                                     <template v-for="valueMetricMonth in metric.data">
                                         <td :key="valueMetricMonth.month_name + '-' + metric.id">
                                            <span :id="'metric-' + metric.id + 'month-' + valueMetricMonth.month"
                                            v-if="valueMetricMonth.value > 0 || metric.pid > 0 || metric.is_category == 0"
                                            @click="openDetail(valueMetricMonth.value_detail, metric.label, metric.id, valueMetricMonth.month)"
                                                class="pointer"
                                                >{{valueMetricMonth.value}}</span>
                                         </td>
                                     </template>
                                     <td align="right">{{metric.data | totalValue}} </td>
                                </tr>
                            </template>
                        </tbody>
                  </table>
              </div>

            </template>
          </b-row>
        </b-card>

        <b-card v-if="urlDetail" id="card-detail">
            <detail-metric
            :url="urlDetail"
            :option="options"
            />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {getService} from '@/services/get.service'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import DetailMetric from './DetailMetric'


export default {
    components: {
        DatePicker,
        DetailMetric,
    },
    created () {
        this.getBranch()
        var that = this
            if (this.$store.getters.branchInVendor) {
                this.branch = this.$store.getters.branchInVendor
            } else {
                this.checkBranch = setInterval(() => {
                    that.branch = that.$store.getters.branch
                    if (that.branch) {
                        clearInterval(that.checkBranch)
                    }
                }, 1000);
            }
    },
    data() {
        return {
            listMetric: [],
            branch: '',
            branchs: [],
            date: moment(),
            year: '',
            editable: false,
            checkBranch: '',
            headerMonth: [],
            urlDetail: '',
            title: '',
            options: {
              year: '',
              month: '',
              label_id: '',
              branch_id: '',
            }
        }
    },
    methods: {
        async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      },
      getListMetricHRGA (year, branch) {
        this.$store.commit('noLoad', true)
          getService.listMetricHRGA(year, branch)
            .then (data => {
              this.$store.commit('noLoad', false)
                // console.log(data)
                this.listMetric = data.metric
                this.headerMonth = this.getHeader(data.metric[0].data)
                // console.log(this.headerMonth)
            })
      },
      getHeader (header) {
          let data = []
          for (let i = 0; i < header.length; i++) {
              data.push(this.insertHeader(header[i].month_name))
          }
          return data
      },
      insertHeader(text) {
          return {'text': text}
      },
        submit () {
            const year = moment(this.date).format('YYYY')
            this.getListMetricHRGA(year, this.branch)
            this.year = moment(this.date).format('YYYY')
        },
        openDetail(url, title, id, month) {
            this.urlDetail = url
            this.title = title
            this.options.year = this.year
            this.options.branch_id = this.branch
            this.options.label_id = id
            this.options.month = month
        }
    },
    filters: {
        totalValue: function (data) {
            let total = 0
            data.forEach(sum => {
                total += Number(sum.value)
            })
            return total
        }
    }
}
</script>
<style scoped>

.b-table-sticky-header {
    max-height: 85vh;
    display: block;
    overflow: scroll;
    width: 100%;
    border-block-end: 1px solid;
  }
  .b-table-sticky-header > .table.b-table > thead > tr > th {
        background-color: antiquewhite;
    }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .parent-category {
      font-weight: 600;
  }

  .child-category{
      padding-inline-start: 10px;
  }

  .pointer{
    cursor: pointer;
  }

  .of-the-year{
    min-width: 150px;
    text-align: right;
  }
  
</style>